import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IGAEADMeetingsService } from "../../services/igaead-meetings.service";

@Component({
    selector: 'app-decision-details-i18n',
    templateUrl: './decision-details-i18n.component.html',
    styleUrls: ['./decision-details-i18n.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DecisionDetailsI18nComponent implements OnInit {

    @Input() decision;
    @Input() decisionView: any;
    @Input() expandAll;
    @Input() expand;
    currentSession;
    currentDoc;
    panelOpenState = false;
    @Input() labels: any;

    filterText: string;
    shouldDisplay: boolean = false;
    isRtl = false;
    @Input('filterText')
    set filterTextSet(value: string) {
        this.filterText = value;
        this.shouldShowBasedOnFilter(this.filterText);
    }


    constructor(private router: Router,
                private currentRoute: ActivatedRoute,
                private meetingService: IGAEADMeetingsService,
                private cd: ChangeDetectorRef,
    ) {
    }

    ngOnInit(): void {
        const ln = this.currentRoute.snapshot.queryParamMap.get('ln');
        if (ln && this.meetingService.allLanguages.includes(ln)) {
            localStorage.setItem('defaultLanguage', ln);
            window.location.href = window.location.origin + window.location.pathname; // Reload page without any query parameters.
        }

        let defaultLang = localStorage.getItem('defaultLanguage') || 'en';
        if (defaultLang === 'ar') this.isRtl = true;

        this.currentSession = this.currentRoute.snapshot.paramMap.get('sessionID');
        this.currentDoc = this.currentRoute.snapshot.queryParamMap.get('document');
        if (this.expandAll) {
            this.panelOpenState = true;
        } else if (this.decision.isDocExist) {
            this.panelOpenState = true;
        }
        this.cd.detectChanges();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.expandAll) {
            this.panelOpenState = true;
        } else {
            this.panelOpenState = false;
        }
        this.cd.detectChanges();
    }

    public openPage(name: string): void {
        this.router.navigate([name], {});
    }

    getSymbols(documents) {
        let links = [];
        if (documents) {
            for (let document of documents) {
                links.push(`<a hreg="https://undocs.org/${document.DD_symbol1}" target="_blank" >${document.DD_symbol1}</a>`)
            }
            return links.join(',');
        }
        return '';
    }

    shouldShowBasedOnFilter(text: string) {
        if (!text) return this.shouldDisplay = true;
        if (!this.decisionView || !this.decision) return this.shouldDisplay = true;

        let isExactMatch = text[0] == '"' && text[text.length - 1] == '"';
        let regx = null;
        if (isExactMatch) {
            text = text.substring(1, text.length - 1);
            regx = new RegExp(`\\b${text}\\b`, 'g')
        } else {
            text = text.toLowerCase();
        }

        this.shouldDisplay = false;
        if (isExactMatch && (
            (this.decisionView.ED_DecisionText || this.decision.ED_DecisionText).match(regx)
            || (this.decisionView.ED_Title || this.decision.ED_Title).match(regx)
            || (this.decisionView.ED_DecisionNumber || this.decision.ED_DecisionNumber).match(regx))
        ) {
            this.shouldDisplay = true;
        }

        if (!isExactMatch && (
            (this.decisionView.ED_DecisionText || this.decision.ED_DecisionText).toLowerCase().indexOf(text) > -1
            || (this.decisionView.ED_Title || this.decision.ED_Title).toLowerCase().indexOf(text) > -1
            || (this.decisionView.ED_DecisionNumber || this.decision.ED_DecisionNumber).toLowerCase().indexOf(text) > -1)
        ) {
            this.shouldDisplay = true;
        }
    }

    changeAccordianState() {
        this.panelOpenState = !this.panelOpenState;
    }
}
